import Error from 'components/alerts/Error';
import { Select } from 'components/common/form/modules/input/Select';
import { ContentLoader } from 'components/common/loader/ContentLoader';
import * as JSCookie from 'js-cookie';
import React from 'react';
import { Input, Label } from 'reactstrap';
import { fetchGraphQL } from 'services/graphql/GraphQL';


export default class ImportSettingsModal extends React.Component<
    {
        [label: string]: any;
    },
    {
        [label: string]: any;
    }
    > {

    public state = {
        isLoading: false,
        activeIndex: 0,
        events: [{
            id: '',
            name: ''
        }],
        checkBoxOptions: {
            publicTickets: false,
            privateTickets: false,
            referralTickets: false,
            teamMembers: false,
            basicInfo: false
        }
    }
    constructor(props) {

        super(props);
        this.onEventChange = this.onEventChange.bind(this)
        this.importData = this.importData.bind(this)

    }

    public componentDidMount() {
        this.setState({ isLoading: true })

        fetchGraphQL(
            `
                  {
                    event {
                      getByCurrentUser {
                        id
                        name
                        isActive
                      }
                    }
                  }
                `,
            JSCookie.get("token")
        ).then(result => {
            const filteredEvents = result.event.getByCurrentUser.filter(item => {
                return item.id !== this.props.eventId
            })
            this.setState({ events: filteredEvents, isLoading: false })
        })

    }

    public importData() {
        fetchGraphQL(
            `
            mutation { 
              event {
                importSettings(currentEventId:"${this.props.eventId}", 
                importEventId:"${this.state.events[this.state.activeIndex].id}", 
                teamMembers:${Boolean(this.state.checkBoxOptions.teamMembers)},
                basicInfo:${Boolean(this.state.checkBoxOptions.basicInfo)},  
                publicTickets:${Boolean(this.state.checkBoxOptions.publicTickets)}, 
                privateTickets:${Boolean(this.state.checkBoxOptions.privateTickets)}, 
                referralTickets:${Boolean(this.state.checkBoxOptions.referralTickets)})
              }
            }
            `
            , JSCookie.get("token")
        ).then(result => {
            window.location.reload();
        })
        this.props.onClose();
    }

    public onEventChange(e: any) {
        const { value } = e.target;
        this.setState({ activeIndex: value })
    }

    public render() {
        // console.log(this.state.activeIndex)
        const eventContent = (
            this.state.events.map((item, index) => {
                return (
                    <option
                        key={"eventId-" + item.id}
                        value={index}
                    >
                        {item.name}
                    </option>
                )
            })
        );
        // console.log(this.state.activeIndex)
        if (this.state.events === undefined || this.state.events === null || this.state.events.length === 0) {
            return <Error content="No events found to import from" />
        } else {
            return (
                <ContentLoader isLoading={this.state.isLoading}>
                    <div>
                        <Select
                            label="Choose event"
                            value={this.state.activeIndex}
                            name="event"
                            onChange={e => this.onEventChange(e)}
                        >
                            {eventContent}
                        </Select>
                    </div>
                    <br />
                    <Label className="sexyBlack">Details&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Label>
                    <Input
                        type="checkbox"
                        checked={this.state.checkBoxOptions.basicInfo}
                        onChange={e => {
                            if (e.target.checked === true) {
                                this.setState({
                                    checkBoxOptions: {
                                        ...this.state.checkBoxOptions,
                                        basicInfo: true
                                    }
                                })
                            } else {
                                this.setState({
                                    checkBoxOptions: {
                                        ...this.state.checkBoxOptions,
                                        basicInfo: false
                                    }
                                })
                            }
                        }}
                        style={{ height: 'auto' }}
                    />

                    <br />
                    <Label className="sexyBlack">Team&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Label>
                    <Input
                        type="checkbox"
                        style={{ height: 'auto' }}
                        checked={this.state.checkBoxOptions.teamMembers}
                        onChange={e => {
                            if (e.target.checked === true) {
                                this.setState({
                                    checkBoxOptions: {
                                        ...this.state.checkBoxOptions,
                                        teamMembers: true
                                    }
                                })
                            } else {
                                this.setState({
                                    checkBoxOptions: {
                                        ...this.state.checkBoxOptions,
                                        privateTickets: false,
                                        teamMembers: false,
                                        referralTickets: false
                                    }
                                })
                            }
                        }}
                    />

                    <br />
                    <Label className="sexyBlack">General Ticket Inventory&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Label>
                    <Input
                        type="checkbox"
                        style={{ height: 'auto' }}
                        checked={this.state.checkBoxOptions.publicTickets}
                        onChange={e => this.setState({
                            checkBoxOptions: {
                                ...this.state.checkBoxOptions,
                                publicTickets: e.target.checked
                            }
                        })}
                    />

                    <br />
                    <Label className="sexyBlack">Promoter Ticket Inventory&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Label>
                    <Input
                        type="checkbox"
                        style={{ height: 'auto' }}
                        checked={this.state.checkBoxOptions.privateTickets}
                        onChange={e => {
                            if (e.target.checked === true) {
                                this.setState({
                                    checkBoxOptions: {
                                        ...this.state.checkBoxOptions,
                                        privateTickets: true,
                                        teamMembers: true
                                    }
                                })
                            } else {
                                this.setState({
                                    checkBoxOptions: {
                                        ...this.state.checkBoxOptions,
                                        privateTickets: e.target.checked
                                    }
                                })
                            }
                        }}
                    />

                    <br />
                    <Label className="sexyBlack">Referral Links&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Label>
                    <Input
                        type="checkbox"
                        checked={this.state.checkBoxOptions.referralTickets}
                        style={{ height: 'auto' }}
                        onChange={e => {
                            if (e.target.checked === true) {
                                this.setState({
                                    checkBoxOptions: {
                                        ...this.state.checkBoxOptions,
                                        referralTickets: true,
                                        teamMembers: true
                                    }
                                })
                            } else {
                                this.setState({
                                    checkBoxOptions: {
                                        ...this.state.checkBoxOptions,
                                        referralTickets: e.target.checked
                                    }
                                })
                            }
                        }}
                    />

                    <br /><br />
                    <div className="Seperate-Buttons">

                        <button
                            className='new-button-white-3'
                            style={{ border: 'none' }}
                            onClick={this.props.onClose}
                        >
                            CANCEL
                        </button>


                        {this.state.events.length === 0 ? null : (
                            <button
                                className="new-button-white-3"
                                style={{ border: 'none' }}
                                onClick={this.importData}
                            >
                                IMPORT SETTINGS
                            </button>
                        )}
                    </div>

                </ContentLoader>
            );
        }

    }

}


// WEBPACK FOOTER //
// ./src/pages/manage/events/edit/modules/ImportSettingsModal.tsx